
require('./aggregatorCredentialsPSD2Styles.scss')

// @ vendors
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

// @ components
import AggregatorAddEntityLayout from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityLayout/aggregatorAddEntityLayout';
import AggregatorPSD2Token from './aggregatorPSD2Token';

class AggregatorCredentialsPSD2Token extends Component {

    continueFlowCallback = areCredentialsOk => {
        areCredentialsOk ?
            this.props.history.push('/myprofile/global/entities/add/token/ok') :
            this.props.history.push('/myprofile/global/entities/add/token/ko')
    }

    render() {
        return (
            <AggregatorAddEntityLayout>
                <AggregatorPSD2Token
                    continueFlowCallback={(areCredentialsOk) => this.continueFlowCallback(areCredentialsOk)}
                />
            </AggregatorAddEntityLayout>
        )
    }
}


AggregatorCredentialsPSD2Token.propTypes = {
    history: PropTypes.object.isRequired,
}
export default withRouter(AggregatorCredentialsPSD2Token)
